var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79289 15.4571C5.40237 15.0666 5.40237 14.4334 5.79289 14.0429L11.2929 8.54289C11.6834 8.15237 12.3166 8.15237 12.7071 8.54289L18.2071 14.0429C18.5976 14.4334 18.5976 15.0666 18.2071 15.4571C17.8166 15.8476 17.1834 15.8476 16.7929 15.4571L12 10.6642L7.20711 15.4571C6.81658 15.8476 6.18342 15.8476 5.79289 15.4571Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChevronUp);
export default __webpack_public_path__ + "static/media/line-chevron-up.69bea57ab4cf2ffe3632bd7597303ec2.svg";
export { ForwardRef as ReactComponent };